import { t } from './model/Translation';

export interface MenuItem {
    title: string;
    icon?: string;
    href?: string;
    subs?: MenuItem[];
}

export const mainNavLinks = (): MenuItem[] => [
    { href: '#/', title: t('console'), icon: 'terminal' },
    {
        href: '#/work-order',
        title: t('work_order_management'),
        icon: 'file-text'
    },
    {
        title: t('work_order_classification_optimization'),
        icon: 'magic',
        subs: [
            {
                href: '#/task/optimization/creator',
                title: t('create_optimization_task')
            },
            {
                href: '#/task/classification',
                title: t('classification_task_management')
            }
        ]
    },
    {
        title: t('duplicate_work_order_extraction'),
        icon: 'phone',
        subs: [
            {
                href: '#/task/deduplication/creator',
                title: t('create_extraction_task')
            },
            {
                href: '#/task/deduplication',
                title: t('deduplication_task_list')
            }
        ]
    },
    {
        title: t('sensitive_rule_list'),
        icon: 'shield-exclamation',
        subs: [
            {
                href: '#/task/sensitive/creator',
                title: t('create_sensitive_task')
            },
            {
                href: '#/task/sensitive',
                title: t('sensitive_task_list')
            }
        ]
    },
    {
        title: t('responsible_rule_list'),
        icon: 'shield-check',
        subs: [
            {
                href: '#/task/responsible/creator',
                title: t('create_responsible_task')
            },
            {
                href: '#/task/responsible',
                title: t('responsible_task_list')
            }
        ]
    },
    {
        title: t('supervision_order_intelligent_generation'),
        icon: 'file-earmark-text',
        subs: [
            {
                href: '#/supervision-order',
                title: t('supervision_order_list')
            }
        ]
    },
    {
        title: t('report_management'),
        icon: 'graph-up-arrow',
        subs: [
            { href: '#/report', title: t('report_analysis_center') },
            {
                href: '#/report/template',
                title: t('report_template_management')
            }
        ]
    },
    {
        title: t('rule_knowledge_base'),
        icon: 'book',
        subs: [
            { href: '#/category', title: t('category_system') },
            { href: '#/rule/sensitive', title: t('sensitive_rule_list') },
            { href: '#/rule/responsible', title: t('responsible_rule_list') },
            { href: '#/document', title: t('document_knowledge_base') }
        ]
    }
];
